import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-m-4"
}
const _hoisted_2 = {
  key: 0,
  class: "p-field"
}
const _hoisted_3 = { class: "p-float-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-sorting-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.olapSortingDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.sidebar.sortingSettings')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.save
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.olap)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.olapSortingDialogDescriptor.sortingModes, (mode, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "p-field-radiobutton",
                key: index
              }, [
                _createVNode(_component_RadioButton, {
                  name: "sorting",
                  value: mode,
                  modelValue: _ctx.sortingMode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortingMode = $event))
                }, null, 8, ["value", "modelValue"]),
                _createVNode("label", null, _toDisplayString(mode), 1)
              ]))
            }), 128)),
            (_ctx.sortingMode === 'count')
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("span", _hoisted_3, [
                    _createVNode(_component_InputText, {
                      id: "sortingCount",
                      type: "number",
                      class: "kn-material-input",
                      modelValue: _ctx.sortingCount,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortingCount = $event)),
                      modelModifiers: { trim: true },
                      min: 1
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}